import React, { useState, useEffect, useMemo } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { db } from '../firebase';
import { doc, collection, query, where, onSnapshot, updateDoc, deleteDoc, serverTimestamp } from 'firebase/firestore';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable'; 
import * as XLSX from 'xlsx'; 

// Cari Düzenleme Modalı (Bilgileri güncellemek için)
import CariDuzenleModal from '../components/CariDuzenleModal'; 

// --- Yardımcı Fonksiyonlar ---
function formatDate(timestamp) {
  if (!timestamp) return '---';
  // Firebase Timestamp kontrolü
  const date = timestamp.toDate ? timestamp.toDate() : new Date(timestamp);
  return date.toLocaleDateString('tr-TR');
}

function formatCurrency(number) {
    if (typeof number !== 'number') return '0,00 ₺';
    return number.toLocaleString('tr-TR', { style: 'currency', currency: 'TRY' });
}

export default function TedarikciDetay() {
  const { id: cariId } = useParams(); 
  const navigate = useNavigate(); 

  const [cari, setCari] = useState(null);
  const [odemeler, setOdemeler] = useState([]); // Giderler Listesi
  const [loading, setLoading] = useState(true);
  
  // Modal State
  const [isDuzenleModalOpen, setIsDuzenleModalOpen] = useState(false);

  // Tarih/Saat
  const [now, setNow] = useState(new Date());
  useEffect(() => {
    const t = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(t);
  }, []);

  // --- VERİ ÇEKME ---
  useEffect(() => {
    if (!cariId) return;

    // 1. Tedarikçi Kimlik Bilgisi (cariler koleksiyonundan)
    const cariRef = doc(db, 'cariler', cariId);
    const unsubCari = onSnapshot(cariRef, (snap) => {
        if (snap.exists()) {
            setCari({ id: snap.id, ...snap.data() });
        } else {
            console.log("Cari bulunamadı");
        }
    });

    // 2. Borç/Gider Hareketleri (odemeler koleksiyonundan)
    // Tedarikçilerde 'taksitler' yerine 'odemeler' tablosuna bakıyoruz.
    const q = query(collection(db, 'odemeler'), where('cariId', '==', cariId));
    const unsubOdemeler = onSnapshot(q, (snap) => {
        const list = snap.docs.map(d => ({ 
            id: d.id, 
            ...d.data(), 
            // Tarih formatı garantisi
            odemeTarihi: d.data().odemeTarihi 
        })).sort((a, b) => {
            // Tarihe göre sırala (Yeniden eskiye)
            const dateA = a.odemeTarihi?.toDate ? a.odemeTarihi.toDate() : new Date(a.odemeTarihi);
            const dateB = b.odemeTarihi?.toDate ? b.odemeTarihi.toDate() : new Date(b.odemeTarihi);
            return dateB - dateA;
        });
        
        setOdemeler(list);
        setLoading(false);
    });

    return () => { unsubCari(); unsubOdemeler(); };
  }, [cariId]);

  // --- BORÇ HESAPLAMALARI ---
  const { toplamBorc, odenen, kalan } = useMemo(() => {
    // Toplam Gider (Borçlandığımız Miktar)
    const top = odemeler.reduce((acc, o) => acc + (o.miktar || 0), 0);
    
    // Ödenmiş Olanlar
    const ode = odemeler
        .filter(o => o.durum === 'Ödendi')
        .reduce((acc, o) => acc + (o.miktar || 0), 0);
        
    return { toplamBorc: top, odenen: ode, kalan: top - ode };
  }, [odemeler]);

  // --- İŞLEMLER ---
  const handleDurumDegistir = async (odeme, yeniDurum) => {
      if(!window.confirm(`${formatCurrency(odeme.miktar)} tutarındaki işlem '${yeniDurum}' olarak işaretlensin mi?`)) return;
      try {
          await updateDoc(doc(db, 'odemeler', odeme.id), { 
              durum: yeniDurum,
              islemTarihi: serverTimestamp() 
          });
      } catch(e) { alert("Hata oluştu: " + e.message); }
  };

  const handleSil = async (id) => {
      if(!window.confirm("Bu gider kaydını silmek istediğinize emin misiniz?")) return;
      try { await deleteDoc(doc(db, 'odemeler', id)); } catch(e) { alert("Silinemedi."); }
  };

  // --- RAPORLAR (PDF / EXCEL) ---
  const handlePdf = () => {
      const doc = new jsPDF();
      doc.setFontSize(18);
      doc.text(`Tedarikçi Ekstresi: ${cari.firmaSahis || cari.adSoyad}`, 14, 20);
      doc.setFontSize(10);
      doc.text(`Tarih: ${new Date().toLocaleDateString('tr-TR')}`, 14, 26);

      autoTable(doc, {
          head: [['Tarih', 'Tutar', 'Durum']],
          body: odemeler.map(o => [
            formatDate(o.odemeTarihi), 
            formatCurrency(o.miktar), 
            o.durum
          ]),
          startY: 35
      });
      doc.save('Tedarikci_Ekstre.pdf');
  };

  const handleExcel = () => {
      const ws = XLSX.utils.json_to_sheet(odemeler.map(o => ({
          Tarih: formatDate(o.odemeTarihi),
          Tutar: o.miktar,
          Durum: o.durum
      })));
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Ekstre");
      XLSX.writeFile(wb, "Tedarikci_Ekstre.xlsx");
  };

  if (loading) return <div className="admin-page"><p className="loading-text">Yükleniyor...</p></div>;
  if (!cari) return <div className="admin-page"><p className="login-error">Kayıt bulunamadı.</p></div>;

  return (
    <>
      <div className="admin-page">
        
        {/* --- MODERN HEADER --- */}
        <div className="admin-header">
          <h1 
            className="brand-logo admin-brand-header" 
            onClick={() => navigate('/admin/dashboard')} 
            style={{cursor:'pointer', flex: 1}}
            title="Admin Paneline Dön"
          >
            <img src="/logo.png" width="50" alt="" />
            ARAS ASAF – TEDARİKÇİ DETAYI
          </h1>
          
          <div style={{display:'flex', gap:'10px', alignItems:'center'}}>
              <div className="date-time-info" style={{marginRight: '10px'}}>
                {now.toLocaleDateString("tr-TR")} | {now.toLocaleTimeString("tr-TR")}
              </div>
              
              {/* DÜZENLEME BUTONU */}
              <button 
                  onClick={() => setIsDuzenleModalOpen(true)} 
                  className="admin-button"
                  style={{ padding: '10px 20px', fontSize: '0.9rem', display: 'flex', alignItems: 'center', gap: '8px' }}
              >
                  ✏️ Tedarikçi Cari Düzenle
              </button>

              <button onClick={() => navigate(-1)} className="admin-button-secondary small">
                ← Geri
              </button>
          </div>
        </div>

        {/* --- BİLGİ KARTLARI --- */}
        <div className="form-section">
            <div className="customer-detail-grid">
              <div className="customer-info">
                <h2>{cari.firmaSahis || cari.adSoyad}</h2>
                <div className="info-item"><strong>Yetkili:</strong> {cari.adSoyad}</div>
                <div className="info-item"><strong>Tel:</strong> {cari.telefon}</div>
                <div className="info-item"><strong>Adres/Not:</strong> {cari.adres || '---'}</div>
              </div>
              
              <div className="customer-summary">
                <div className="summary-box">
                    <span>Toplam Borcunuz</span>
                    <p>{formatCurrency(toplamBorc)}</p>
                </div>
                <div className="summary-box paid">
                    <span>Ödenen</span>
                    <p>{formatCurrency(odenen)}</p>
                </div>
                <div className="summary-box pending" style={{borderLeftColor: '#dc3545'}}>
                    <span>Kalan Borç</span>
                    <p style={{color: '#dc3545'}}>{formatCurrency(kalan)}</p>
                </div>
              </div>
            </div>
        </div>

        {/* --- HAREKET TABLOSU --- */}
        <div className="admin-table-container">
            <div className="taksit-controls">
              <h2>Borç / Gider Hareketleri</h2>
              <div>
                  <button onClick={handlePdf} className="admin-button-secondary small">PDF Aktar</button>
                  <button onClick={handleExcel} className="admin-button-secondary small">Excel Aktar</button>
              </div>
            </div>
            
            <table className="admin-table">
                <thead>
                    <tr>
                        <th>Tarih</th>
                        <th>Tutar</th>
                        <th>Durum</th>
                        <th>İşlem</th>
                    </tr>
                </thead>
                <tbody>
                    {odemeler.map(o => (
                        <tr key={o.id}>
                            <td>{formatDate(o.odemeTarihi)}</td>
                            <td>{formatCurrency(o.miktar)}</td>
                            <td>
                                <span className={o.durum === 'Ödendi' ? 'status-paid' : 'status-pending'}>
                                    {o.durum}
                                </span>
                            </td>
                            <td>
                                {o.durum !== 'Ödendi' && (
                                    <button onClick={() => handleDurumDegistir(o, 'Ödendi')} className="admin-button-odeme small">Ödendi Yap</button>
                                )}
                                <button onClick={() => handleSil(o.id)} className="admin-button-delete small" style={{marginLeft:'5px'}}>Sil</button>
                            </td>
                        </tr>
                    ))}
                    {odemeler.length === 0 && (
                        <tr><td colSpan="4" style={{textAlign:'center', color:'#999'}}>Henüz kayıtlı bir işlem yok.</td></tr>
                    )}
                </tbody>
            </table>
        </div>
      </div>

      {/* --- DÜZENLEME MODALI --- */}
      <CariDuzenleModal
        show={isDuzenleModalOpen}
        onClose={() => setIsDuzenleModalOpen(false)}
        cariData={cari}
        // ÖNEMLİ: Tedarikçi için 'odemeler' listesini gönderiyoruz
        // Böylece yeniden yapılandırma yapılırsa eski ödemeler silinip yenileri eklenir.
        taksitData={odemeler} 
      />
    </>
  );
}